<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Procedimento"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="5">
                    <rkm-form-input-autocomplete
                        :disabled="!!item"
                        :repository="repositories.procedimento"
                        :request-query-string-params="requestQueryStringParams.procedimento"
                        :search-fields="fields.procedimento"
                        :text-field="(item) => `${formatProcedimento(item.codigo)} - ${item.nome}`"
                        :validations="validations.procedimento"
                        @select="model.cid = null"
                        label="Procedimento"
                        v-model="model.procedimento"
                    />
                </rkm-col>

                <rkm-col cols="5">
                    <rkm-form-input-autocomplete
                        :disabled="!model.procedimento"
                        :repository="repositories.cid"
                        :request-query-string-params="requestQueryStringParams.cid"
                        :search-fields="fields.cid"
                        :text-field="(item) => `${formatCid(item.codigo)} - ${item.nome}`"
                        :validations="validations.cid"
                        label="CID"
                        v-model="model.cid"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.quantidade"
                        label="Quantidade"
                        number
                        v-model="model.quantidade"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                {{item ? 'Salvar' : 'Incluir'}}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {formats, object, repository} from '@/mixins'

// Enums.
import procedimentoAtencaoBasica from '@/enums/atencao-basica/atendimento-odontologico/procedimento'

export default {
    computed: {
        requestQueryStringParams() {
            return {
                procedimento: {
                    cbo_lotacao_atual: true,
                    paciente_id: this.data.additionals.paciente.id,
                    competencia_id: this.data.additionals.isRetroativo ? this.data.additionals.agendamentoCompetenciaId : null,
                },
                cid: this.model.procedimento && this.model.procedimento.hasCidPrincipal
                    ? {
                        principal: true,
                        procedimento_id: this.model.procedimento.id,
                    }
                    : {}
            }
        },
        validations() {
            return {
                procedimento: {required: true},
                cid: {required: this.model.procedimento && !!this.model.procedimento.hasCidPrincipal},
                quantidade: {
                    required: true,
                    min_value: 1,
                    max_value: this.data.additionals.isAtendimentoSaudeBucal ? this.getMaxValue() : 3,
                },
            }
        },
    },
    created() {
        this.repositories = {
            cid: this.getConectaSusRepository('sigtap.cid'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
        }
    },
    data: () => ({
        enums: {procedimentoAtencaoBasica},
        fields: {
            procedimento: [
                {key: 'codigo', searchable: true},
                {key: 'nome', searchable: true},
            ],
            cid: [
                {key: 'codigo', searchable: true},
                {key: 'nome', searchable: true},
            ],
        },
        item: null,
        model: {
            procedimento: null,
            cid: null,
            quantidade: 1,
        },
    }),
    methods: {
        open(item = null) {
            this.item = item

            if (this.item) {
                this.edit()
            } else {
                this.create()
            }

            this.$refs.RkmModal.show()
        },
        create() {
            this.resetForm()
        },
        edit() {
            this.model = this.clone({
                procedimento: this.item.procedimento,
                cid: this.item.cid,
                quantidade: this.item.quantidade,
            })
        },
        store() {
            this.data.model.procedimentos.push(this.prepareData())
        },
        update() {
            Object.assign(this.item, this.prepareData())
        },
        prepareData() {
            return {
                procedimento: {
                    id: this.model.procedimento.id,
                    codigo: this.model.procedimento.codigo,
                    nome: this.model.procedimento.nome,
                    hasCidPrincipal: this.model.procedimento.hasCidPrincipal,
                },
                cid: this.model.cid ? {
                    id: this.model.cid.id,
                    codigo: this.model.cid.codigo,
                    nome: this.model.cid.nome,
                } : null,
                quantidade: this.model.quantidade,
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (!this.item && this.data.model.procedimentos.find(procedimentos => procedimentos.procedimento.id === this.model.procedimento.id)) {
                        this.showValidationNotification('O procedimento já foi incluído.')
                        return
                    }

                    if (this.item) {
                        this.update()
                    } else {
                        this.store()
                    }

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.model.procedimento = null
            this.model.cid = null
            this.model.quantidade = 1
        },
        getMaxValue() {
            if(this.model.procedimento) {
                if([
                    this.enums.procedimentoAtencaoBasica.RADIOGRAFIA_OCLUSAL,
                    this.enums.procedimentoAtencaoBasica.COLOCACAO_PLACA_MORDIDA,
                    this.enums.procedimentoAtencaoBasica.MANUTENCAOO_CONSERTO_APARELHO,
                    this.enums.procedimentoAtencaoBasica.CONTENCAOO_DENTES_SPLINTAGEM,
                    this.enums.procedimentoAtencaoBasica.REDUCAO_LUXACAOO_TEMPORO_MANDIBULAR,
                    this.enums.procedimentoAtencaoBasica.RETIRADA_MATERIAL_SÍNTESE,
                    this.enums.procedimentoAtencaoBasica.EXERESE_CISTO,
                    this.enums.procedimentoAtencaoBasica.TRATAMENTO_CIRURGICO_FISTULA,
                    this.enums.procedimentoAtencaoBasica.CORRECAO_BRIDAS_MUSCULARES,
                    this.enums.procedimentoAtencaoBasica.CORRECAO_IRREGULARIDADES_REBORDO_ALVEOLAR,
                    this.enums.procedimentoAtencaoBasica.REMOCAO_TORUS_EXOSTOSES,
                    this.enums.procedimentoAtencaoBasica.MANTENEDOR_ESPAÇO,
                    this.enums.procedimentoAtencaoBasica.PLACA_OCLUSAL,
                    this.enums.procedimentoAtencaoBasica.PLANO_INCLINADO,
                    this.enums.procedimentoAtencaoBasica.PROTESE_PARCIAL_MANDIBULAR_REMOVIVEL,
                    this.enums.procedimentoAtencaoBasica.PROTESE_PARCIAL_MAXILAR_REMOVIVEL,
                    this.enums.procedimentoAtencaoBasica.PROTESE_TEMPORARIA,
                    this.enums.procedimentoAtencaoBasica.PROTESE_TOTAL_MANDIBULAR,
                    this.enums.procedimentoAtencaoBasica.PROTESE_TOTAL_MAXILAR,
                    this.enums.procedimentoAtencaoBasica.MOLDAGEM_DENTO_GENGIVAL,

                ].includes(this.model.procedimento.codigo)) {
                    return 2
                }
                if([
                    this.enums.procedimentoAtencaoBasica.APLICACAO_CARIOSTATICO,
                    this.enums.procedimentoAtencaoBasica.APLICACAO_SELANTE,
                    this.enums.procedimentoAtencaoBasica.SELAMENTO_PROVISORIO_CAVIDADE_DENTARIA,
                    this.enums.procedimentoAtencaoBasica.RADIOGRAFIA_INTERPROXIMAL,
                    this.enums.procedimentoAtencaoBasica.RADIOGRAFIA_PERIAPICAL,
                    this.enums.procedimentoAtencaoBasica.CAPEAMENTO_PULPAR,
                    this.enums.procedimentoAtencaoBasica.RESTAURACAO_DENTE_PERMANENTE_ANTERIOR,
                    this.enums.procedimentoAtencaoBasica.TRATAMENTO_INICIAL_DENTE_TRAUMATIZADO,
                    this.enums.procedimentoAtencaoBasica.TRATAMENTO_RESTAURADOR_ATRAUMATICO,
                    this.enums.procedimentoAtencaoBasica.RESTAURACAO_DENTEDECIDUO_POSTERIOR_RESINA_COMPOSTA,
                    this.enums.procedimentoAtencaoBasica.RESTAURACAO_DENTE_DECIDUO_POSTERIOR_AMALGAMA,
                    this.enums.procedimentoAtencaoBasica.RESTAURACAO_DENTE_DECIDUO_POSTERIOR_IONOMERO_VIDRO,
                    this.enums.procedimentoAtencaoBasica.RESTAURACAO_DENTE_DECIDUO_ANTERIOR_RESINA_COMPOSTA,
                    this.enums.procedimentoAtencaoBasica.RESTAURACAO_DENTE_PERMANENTE_POSTERIOR_RESINA_COMPOSTA,
                    this.enums.procedimentoAtencaoBasica.RESTAURACAO_DENTE_PERMANENTE_POSTERIOR_AMALGAMA,
                    this.enums.procedimentoAtencaoBasica.ACESSO_POLPA_DENTARIA,
                    this.enums.procedimentoAtencaoBasica.CURATIVO_DEMORA,
                    this.enums.procedimentoAtencaoBasica.OBTURACAO_DENTE_DECIDUO,
                    this.enums.procedimentoAtencaoBasica.OBTURACAO_DENTE_PERMANENTE_BIRRADICULAR,
                    this.enums.procedimentoAtencaoBasica.OBTURACAO_DENTE_PERMANENTE_RAIZES,
                    this.enums.procedimentoAtencaoBasica.OBTURACAO_DENTE_PERMANENTE_UNIRRADICULAR,
                    this.enums.procedimentoAtencaoBasica.PULPOTOMIA_DENTARIA,
                    this.enums.procedimentoAtencaoBasica.RETRATAMENTO_ENDODÔNTICO_DENTE_PERMANENTE_BIRADICULAR,
                    this.enums.procedimentoAtencaoBasica.RETRATAMENTO_ENDODÔNTICO_DENTE_PERMANENTE_RAIZES,
                    this.enums.procedimentoAtencaoBasica.RETRATAMENTO_ENDODÔNTICO_DENTE_PERMANENTE_UNIRADICULAR,
                    this.enums.procedimentoAtencaoBasica.SELAMENTO_PERFURACAO_RADICULAR,
                    this.enums.procedimentoAtencaoBasica.MOLDAGEM_PROTESE_DENTARIA,
                    this.enums.procedimentoAtencaoBasica.REEMBASAMENTO_CONSERTO_PROTESE_DENTARIA,
                    this.enums.procedimentoAtencaoBasica.CIMENTACAO_PROTESE_DENTARIA,
                    this.enums.procedimentoAtencaoBasica.ADAPTACAO_PROTESE_DENTARIA,
                    this.enums.procedimentoAtencaoBasica.AJUSTE_OCLUSAL,
                    this.enums.procedimentoAtencaoBasica.INSTALACAO_PROTESE_DENTARIA,
                    this.enums.procedimentoAtencaoBasica.APICECTOMIA,
                    this.enums.procedimentoAtencaoBasica.CURETAGEM_PERIAPICAL,
                    this.enums.procedimentoAtencaoBasica.EXODONTIA_DENTE_DECIDUO,
                    this.enums.procedimentoAtencaoBasica.EXODONTIA_DENTE_PERMANENTE,
                    this.enums.procedimentoAtencaoBasica.ODONTOSECCAO_RADILECTOMIA_TUNELIZACAO,
                    this.enums.procedimentoAtencaoBasica.REIMPLANTE_TRANSPLANTE_DENTAL,
                    this.enums.procedimentoAtencaoBasica.REMOCAO_DENTE_RETIDO,
                    this.enums.procedimentoAtencaoBasica.TRATAMENTO_CIRURGICO_TRACIONAMENTO_DENTAL,
                    this.enums.procedimentoAtencaoBasica.TRATAMENTO_ALVEOLITE,
                    this.enums.procedimentoAtencaoBasica.ULOTOMIA_ULECTOMIA,
                    this.enums.procedimentoAtencaoBasica.COROA_PROVISORIA,
                    this.enums.procedimentoAtencaoBasica.PROTESE_CORONARIAS,

                ].includes(this.model.procedimento.codigo)) {
                    return 32
                }
                if([
                    this.enums.procedimentoAtencaoBasica.RASPAGEM_SUBGENGIVAIS,
                    this.enums.procedimentoAtencaoBasica.RASPAGEM_SUPRAGENGIVAIS,
                    this.enums.procedimentoAtencaoBasica.APROFUNDAMENTO_VESTIBULO_ORAL,
                    this.enums.procedimentoAtencaoBasica.GENGIVECTOMIA,
                    this.enums.procedimentoAtencaoBasica.GENGIVOPLASTIA,
                    this.enums.procedimentoAtencaoBasica.TRATAMENTO_CIRURGICO_PERIODONTAL,
                    this.enums.procedimentoAtencaoBasica.RASPAGEM_CORONO_RADICULAR,
                    this.enums.procedimentoAtencaoBasica.EXODONTIA_MULTIPLA_ALVEOLOPLASTIA,
                ].includes(this.model.procedimento.codigo)) {
                    return 6
                }
            }
            return 1
        },
    },
    mixins: [formats, object, repository],
    props: {
        data: {required: true, type: Object},
    },
}
</script>